"use client";

export const defaultTransitionDuration = parseFloat(
  getComputedStyle(document.documentElement)
    .getPropertyValue("--default-transition-duration")
    .trim(),
);
export const defaultTransitionDurationMs = defaultTransitionDuration * 1000;
